<template>
  <b-row>
    <b-col>
      <explicit-hint
        class="col-md-12"
        :text="`
          We may require additional documents below,
          these are not required to submit your application.
        `"
      />
      <application-form ref="applicationForm" @submit="submit"/>
      <pdf-signature
        ref="appSignature" title="Borrower Application" @pdf-signed="updateApplication"/>
    </b-col>
  </b-row>
</template>

<script>
import helper from '@/libs/helper';
import { DEFINE_PROFILE_APPLICATION } from '@/vuex/modules/profile/types/actions';
import { DEFINE_MISSING_INDICATORS } from '@/vuex/modules/missing/types/actions';
import { DEFINE_DOCUMENTS } from '@/vuex/modules/documents/types/actions';

import ExplicitHint from '@/components/utils/hints/ExplicitHint';
import ApplicationForm from '@/components/profile/sections/tabs/application/form/ApplicationForm';
import PdfSignature from '@/components/utils/PdfSignature';


export default {
  components: {
    ApplicationForm,
    ExplicitHint,
    PdfSignature,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    submit() {
      if (!this.$refs.applicationForm.validate()) {
        return;
      }

      const model = this.$refs.applicationForm.model;
      this.$store.dispatch(DEFINE_PROFILE_APPLICATION, { application: helper.copy(model) });

      this.$reqs.post(`/users/${this.user.id}/profile/application/send`, model)
        .then((response) => {
          window.scrollTo(0, 455);
          this.$refs.appSignature.show(response.data.docusign_url_embedded_signature);
        })
        .catch(() => {
          this.$notify({ group: 'alert', text: 'Failed to communicate with eSignature service.' });
        });
    },
    updateApplication() {
      const data = {
        type: this.$store.getters.profile.application.type,
        entity: this.$store.getters.profile.application.entity,
        signed: true,
      };
      this.$store.dispatch(DEFINE_PROFILE_APPLICATION, { application: data });
      this.$reqs.post(`/users/${this.user.id}/profile/application`, data, { pre: false })
        .then(() => {
          this.getDocuments();
          this.getMissingIndicators();
        });
    },
    getDocuments() {
      this.$reqs.get(`/users/${this.user.id}/docs`)
        .then((response) => {
          this.$store.dispatch(DEFINE_DOCUMENTS, { docs: response.data });
        })
        .catch(() => {});
    },
    getMissingIndicators() {
      this.$reqs.get(`/users/${this.user.id}/indicators`)
        .then((response) => {
          this.$store.dispatch(DEFINE_MISSING_INDICATORS, { missing: response.data });
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/application/ApplicationContent.vue